import Component from "vue-class-component"
import moduleStore from "./store/textGenerateList"
import Vue from "vue"
import PageState from "./store/state"
import { Toast, Dialog } from "vant"
// import Axios from "axios"
// import { getMediaFileDuration } from '../../utils/file'
import { toast } from "@/utils/util"
import { getQueryString } from "@/utils/location"
import { copy } from '@/utils/util'
import { judgeDeviceType } from "@/utils/device";
import LZString from '../../utils/lz-string.min'
import { FUN_DATA } from "@/constants/generateType";
import { customCollectEvent } from '@/utils/collect';
// import {deserialize} from "v8";
/**components**/
@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})

export default class textGenerateListPage extends Vue {
  state = new PageState()
  self: Vue = this
  page = 1
  size = 10
  showTip = false
  durationList = []
  loading = null
  filterType = ""
  pageCount = 0
  tip = ""
  dateFilter = ''
  showcalendar = false
  filterDate = ""
  maxDate = new Date()
  minDate = new Date('2023-09-01')
  currentDate = new Date()
  startDate = ""
  endDate = ""
  gotoTimer = null
  isSearch = false
  DateShow = false
  typeShow = false
  textStatusList = ["正在努力生成中...","正在努力生成中...","暂无内容","暂无内容"]
  typeOption: any = {}
  filterOption = [
    { text: '全部类型', value: "", name: '全部类型' },
    ...FUN_DATA.map((item) => {
      return {
        text: item.text,
        value: item.template_name,
        name: item.text
      }
    })
  ]
  dateOption = [
    { text: '全部日期', value: '' },
    { text: '选择日期', value: '1' },
  ]
  isAPP = judgeDeviceType.isAPP;
  isIOS = judgeDeviceType.isIOS;
  // activeIcon = require("./images/icon_mute_round_nor.png")
  // inactiveIcon = require("./images/icon_mute_round_sel.png")
  created(moduleData: IinjectDatas) {
    // this.vipPermission = this.vipInfo.types
    this.state = <PageState>moduleData.state
    let ww_token = getQueryString("ww_token")
    let wwid = getQueryString("wwid")
    if (ww_token) {
      this.state.ww_token = ww_token
    }
    if(wwid){
        localStorage.setItem("wwid",wwid)
    }
  }

  mounted() {
    clearTimeout(this.gotoTimer)
    if (this.state.ww_token) {
      // this.getGenerateData()
      this.initSearch()
    }
    FUN_DATA.forEach((item) => {
      this.typeOption[item.template_name] = item.text
    })
  }
  getGenerateData() {
    let self = this
    this.isSearch = true
    if (!this.durationList || this.durationList.length == 0) {
      this.loading = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      })
    }

    let data: any = {
      page: this.page,
      size: this.size,
      startDate: this.startDate,
      endDate: this.endDate,
      templateName: this.filterType
    }
    if (this.filterType) {
      data.type = this.filterType
    }
    this.$http("getDataList", data)
      .then((res) => {
        self.isSearch = false
        self.loading.clear()
        self.state.loading = false
        if (res.code == 200) {
          let results = res.data.results || []
          // let results = [];//test
          self.pageCount = res.data.total_pages
          if (self.pageCount == 1) {
            self.tip = "没有更多了~"
            self.state.finished = true
          }
          if (this.pageCount == 0) {
            self.tip = "暂无数据"
            self.state.finished = true
            self.showTip = true
          }

          if (results.length == 0) {
            if (self.page == 1) {
              ; (self.durationList = []), (this.showTip = true)
            }
            return
          }
          results.forEach((item) => {
            item.createdAt = self.expiredAtMap(item.createdAt)
            if (item.param) {
              item.typeName = self.typeOption[item.param.template_name]
            }
            return item
          })

          this.showTip = false
          if (self.page > 1) {
            let durationListAll = [...self.durationList, ...results]
            self.durationList = durationListAll
          } else {
            self.durationList = results
          }
          if (self.page > self.pageCount) {
            self.state.finished = true
          }
        } else {
          toast("服务出错，请稍后重试")
          this.state.finished = true
          this.loading.clear()
          this.page = 1
          this.pageCount = 0
        }
      })
      .catch((err) => {
        toast("服务出错，请稍后重试")
        this.state.finished = true
        this.loading.clear()
        this.isSearch = false
        this.state.loading = false
        console.log("err", err)
      })
  }
  addExtra() {
    
  }
  expiredAtMap(v) {
    if (this.isIOS) {
      return v.split('.')[0]?.replace('T', ' ') || ""
    } else {
      return new Date(v).format("yyyy.MM.dd hh:mm:ss") || ""
    }

  }

  dubbing(text: string) {
    let vm = this;
    if (this.isAPP) {
      let resultTxt = encodeURIComponent(LZString.compressToBase64(text));
      let resultObj = { 'copyText': resultTxt };
      let switchToEditPage: any = (<any>window).switchToEditPage
      switchToEditPage.postMessage(JSON.stringify(resultObj))
    } else {
      localStorage.setItem("articleContent", text);
      sessionStorage.removeItem("articleId");
      vm.$navigateTo({
        url: "/pages/audition-web/audition-web?articleContent=true",
      })
    }
    //校验token
    //内容放到storage

    // this.$navigateTo({
    //   url: `/pages/audition-web/audition-web?from=tool&articleContent=${encodeURIComponent(text)}`,
    // });
    customCollectEvent('tools_aiarticle_list')

  }
  cancelExtract(item) {
    this.$http("deleteTask", { taskId: item.taskId }).then((res: any) => {
      if (res.code == 200) {
        Toast('任务已取消')
        this.initSearch()
      } else {
        Toast('任务取消失败')
      }
    })
    customCollectEvent('tools_aiarticle_lineup')

  }
  copyspan(text: string) {
    if(this.isAPP){
			let setAppClipBoardContent: any = (<any>window).setAppClipBoardContent
			setAppClipBoardContent.postMessage(text)
		}else{
      copy(text).then(() => {
        toast("内容已复制");
      });
    }
    customCollectEvent('tools_aiarticle_list')
  }
  secondToDateArr(time, type) {
    if (time === 0) {
      return "0分钟"
    } else {
      time = type ? time : time / 1000
      var h = Math.floor(time / 3600)
      var m = Math.floor((time / 60) % 60)
      var s = Math.floor(time % 60)
      return [h, m, s]
    }
  }
  _checkToken() {
    return new Promise((resolve, reject) => {
      if (!this.state.ww_token) {
        reject()
        return
      }
      return resolve(true)


    })
  }
  deleteItem(item) {
    let id = item.id
    Dialog.confirm({
      title: '是否确认删除',
      message: '删除后无法恢复，请谨慎操作',
      confirmButtonColor: '#EA4036',
      confirmButtonText: '确定',
      cancelButtonColor: '#EBEBEB',
      cancelButtonText: '取消',
      className: 'warn-dialog',
    })
      .then(() => {
        // on confirm
        this.$http("deleteRecord", { taskId: item.taskId }).then(
          (res) => {
            if (res.code === 200) {
              toast("删除成功")
              this.page = 1
              this.getGenerateData()
            }
          }
        )
      })
      .catch((err) => {
        // on cancel
        console.log('---upType', err)
      });
    customCollectEvent('tools_aiarticle_list')
  }
  onDateConfirm(values) {
    this.DateShow = false;
    const [start, end] = values;
    this.startDate = new Date(start).format('yyyy-MM-dd')
    this.endDate = new Date(end).format('yyyy-MM-dd')
    this.filterDate = `${this.startDate}-${this.endDate}`
    this.initSearch()
  }
  filterChange() {
    console.log(this.filterType);
    this.initSearch()
    customCollectEvent('tools_aiarticle_select')
  }
  initSearch() {
    this.durationList = []
    this.state.finished = false
    this.state.loading = false
    this.page = 1
    this.getGenerateData()
    this.page++

  }
  goToGenerate() {
    //校验token是否过期
    let token = this.state.ww_token

    if (!token) {
      this.$navigateTo({
        url: "/pages/login/login",
      })
      return
    }
    if (this.isAPP) {
      let switchOneKeyGenerateDoc: any = (<any>window).switchOneKeyGenerateDoc
      switchOneKeyGenerateDoc.postMessage('')
    } else {
      localStorage.setItem("articleContent", "");
      this.$router.push({
        path: "/textGenerate",
        query: {
          ...this.$route.query
        },
      })
    }

    // let url=`/#/fileExtract?upType=${type==1?'link':'video'}&ww_token=${this.state.ww_token}`
    // location.href=url
    // let path=`/webviews/pages/webview/webview?from=tool&to=extract&url=${encodeURIComponent(url)}`
    // this._checkToken().then((res: any) => {
    //   if (res.err_code != 306 && res.err_code != -2) {
    //     this.$navigateTo({
    //       url:path,
    //     })
    //   }
    // })
  }

  dateChange(type) {
    let dateItem = this.$refs.dateItem as any
    dateItem.toggle();
    if (type == 'all') {
      this.filterDate = ''
      this.DateShow = false;
      this.startDate = ''
      this.endDate = ''
      this.initSearch()
    } else if (type == 'single') {
      this.currentDate = new Date()
      this.DateShow = true
    }
    customCollectEvent('tools_aiarticle_select')

  }
  generateText(text: string) {
    localStorage.setItem("articleContent", text);
    if(this.isAPP){
			//app修改标题栏
			let secondEditApp=(window as any).secondEditApp 
			secondEditApp.postMessage(encodeURIComponent(text))
		}else{
      this.$router.push({
        path: "/textGenerate",
        query: {
          ...this.$route.query
        }
      })
    }
    customCollectEvent('tools_aiarticle_list')
  }
  onLoad() {
    this.state.loading = true
    if (this.isSearch) {
      return
    }

    this.state.finished = false
    this.getGenerateData()
    this.page++

  }
}
